export enum AttributeUnitsEnum {
    Kilometers = 'km',
    Meters = 'm',
    Kilograms = 'kg'
}
